import { render, staticRenderFns } from "./liked-page.vue?vue&type=template&id=5f7d7266&scoped=true"
import script from "./liked-page.vue?vue&type=script&lang=js"
export * from "./liked-page.vue?vue&type=script&lang=js"
import style0 from "./liked-page.vue?vue&type=style&index=0&id=5f7d7266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d7266",
  null
  
)

export default component.exports